module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-6.00bf2a7d.svg";